exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-5b2beaae] {\n  font-size: 11px;\n}\n.fa-stack[data-v-5b2beaae] {\n  font-size: 11px;\n}\n.fa-backward[data-v-5b2beaae]::before {\n  margin-left: -5px;\n}\n", ""]);

// exports
